import { render, staticRenderFns } from "./AppShare.vue?vue&type=template&id=54bbfc68&scoped=true&"
import script from "./AppShare.vue?vue&type=script&lang=ts&"
export * from "./AppShare.vue?vue&type=script&lang=ts&"
import style0 from "./AppShare.vue?vue&type=style&index=0&id=54bbfc68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bbfc68",
  null
  
)

export default component.exports